import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

interface Props extends Omit<TooltipProps, 'title'> {
  hide?: boolean;
  title?: string;
  wrapChildren?: boolean;
}

export const MissingPermissionTooltip = ({
  children,
  hide = false,
  title = 'You are missing permissions to perform this action',
  wrapChildren = false,
  ...props
}: Props) => {
  if (hide) {
    return <>{children}</>;
  }

  return (
    <Tooltip placement="bottom-start" title={title} {...props}>
      {wrapChildren ? <span style={{ cursor: 'not-allowed' }}>{children}</span> : children}
    </Tooltip>
  );
};
